<template>
  <article>
    <div style="background:#eee;padding: 20px">
      <Card :bordered="false">
        <h4 slot="title">港澳台/外籍人士验证</h4>
        <Row>
          <Col span='12'>
            <h5>证件照正面</h5>
            <Upload :on-exceeded-size='maxSizeErr' ref="uploadFirstCardImg" v-if="canUpLoad" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="handleFormatError"
              :max-size="4096" :data="uploadData" :before-upload="()=>handleBeforeUpload('cardImg')" :on-success="handleSuccess" action="//upload.qiniup.com">
              <div v-if="!cardImg" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>证件照正面</p>
              </div>
              <div v-if="cardImg" class="img-box">
                <img class="img" :src="cardImg" alt="" width="100%">
                <div class="upload-bord">
                  <p>
                    <Icon type="md-add-circle" style="font-size:40px"></Icon>
                  </p>
                  <p>证件照正面</p>
                </div>
              </div>
            </Upload>
            <div v-if="!canUpLoad" class="cardImg">
              <div class="upload-box">
                <img class="img" :src="cardImg" alt="" width="100%">
              </div>
            </div>
          </Col>
          <Col span='12'>
            <h5>人脸照正面</h5>
            <Upload :on-exceeded-size='maxSizeErr' ref="uploadSecondCardImg" v-if="canUpLoad" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="handleFormatError"
              :max-size="4096" :data="uploadData" :before-upload="()=>handleBeforeUpload('faceImg')" :on-success="handleSuccess" action="//upload.qiniup.com">
              <div v-if="!faceImg" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>人脸照正面</p>
              </div>
              <div v-if="faceImg" class="img-box">
                <img class="img" :src="faceImg" alt="" width="100%">
                <div class="upload-bord">
                  <p>
                    <Icon type="md-add-circle" style="font-size:40px"></Icon>
                  </p>
                  <p>人脸照正面</p>
                </div>
              </div>
            </Upload>
            <div v-if="!canUpLoad" class="cardImg">
              <div class="upload-box">
                <img class="img" :src="faceImg" alt="" width="100%">
              </div>
            </div>
          </Col>
        </Row>
        <Form>
          <FormItem class="tableForm" label="姓名：" :label-width="100">
            <span>{{cerInfo.name || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="证件号码：" :label-width="100">
            <span>{{cerInfo.cardId || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="有效期：" :label-width="100">
            <span>{{cerInfo.idValidDate || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="证件类型：" :label-width="100">
            <span>{{['','回乡证','台胞证','护照'][cerInfo.cardType] || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="审核状态：" :label-width="100">
            <span>{{['未验证','待验证','已验证','审核不通过'][cerInfo.status] || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="审核反馈：" :label-width="100">
            <span>{{cerInfo.remark || '-'}}</span>
          </FormItem>
        </Form>
        <Row>
          <Button @click="editModalBtn" type="primary" :disabled="!(faceImg&&cardImg)">编辑审核</Button>
        </Row>
      </Card>
    </div>
    <Modal v-model="editModal" ref="editModal" :loading="true" title="编辑审核" ok-text="提交" @on-ok="subCertificate" @on-cancel="cancel">
      <Form :model="cerInfoModal" ref="cerInfoForm" :rules="rules">
        <FormItem label="姓名" :label-width="85" prop="name">
          <Input v-model="cerInfoModal.name" placeholder="请输入关键字"></Input>
        </FormItem>
        <FormItem label="证件号码" :label-width="85" prop="cardId">
          <Input v-model="cerInfoModal.cardId" placeholder="请输入关键字"></Input>
        </FormItem>
        <FormItem label="有效期" :label-width="85" prop="endDate">
          <Row>
              <DatePicker type="date" v-model="cerInfoModal.endDate" format="yyyy.MM.dd" placeholder="到期日期" transfer></DatePicker>
          </Row>
        </FormItem>
        <FormItem label="证件类型" :label-width="85" prop="cardType">
          <Select v-model="cerInfoModal.cardType" style="width:200px" transfer>
            <Option :value="1">回乡证</Option>
            <Option :value="2">台胞证</Option>
            <Option :value="3">护照</Option>
          </Select>
        </FormItem>
        <FormItem label="审核状态" :label-width="85" prop="status">
          <Select v-model="cerInfoModal.status" style="width:200px" transfer>
            <Option :value="2">已验证</Option>
            <Option :value="3">审核不通过</Option>
          </Select>
        </FormItem>
        <FormItem v-if="cerInfoModal.status==3" label="审核反馈" :label-width="85" prop="remark">
          <Input v-model="cerInfoModal.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
    </Modal> 
  </article>
</template>
<script>
import {chEnRegExp} from "../../../utils/regular";
import Moment from "moment";
import Utils from "../../../utils";
export default {
  created() {
    this.canEdit = Utils.hasPermission('oms_userInfo_certificateAudit');
  },
  props: ['info','token','img-token'],
  computed: {
    canUpLoad(){
      return (this.cerInfo.status==0 || this.cerInfo.status==3)
    }
  },
  watch: {
    info(val) {
      if(Object.keys(val).length !== 0) {
        this.cerInfo.name = val.name;
        this.cerInfo.userId = val.userId;
        this.cerInfo.cardId = val.certificateIdNo;
        this.cerInfo.cardType = val.certificateType;
        this.cerInfo.endDate = val.certificateValid ? val.certificateValid.replace(/\./g,'/') : '';
        this.cerInfo.idValidDate = val.certificateValid ? val.certificateValid: '';
        this.cerInfo.status = val.certificateAuditStatus;
        this.cerInfo.remark = (val.certificateAuditStatus==3?val.certificateRejectReason:'');
        this.cardImg = val.image1;
        this.faceImg = val.image2;
      }
    },
    token(val) {
      if(val) this.uploadData.token = val;
    },
    imgToken(val) {
      if(val && this.uploadRole) {
        this.uploadRole == 'cardImg' ? this.cardImg = val : this.faceImg = val;
        this.uploadRole = '';
      }
    }
  },
  data() {
    const required = (rule, value, callback)=>{
      console.info(rule);
      if(value.trim() === '') {
        callback(new Error('请填写审核反馈'))
      }else {
        callback();
      }
    }
    return {
      editModal: false,
      cerInfo: {
        status: '', 
        userId: '',
        name: '',
        cardId: '',
        startDate: '',
        idValidDate: '',
        endDate: '',
        cardType: '',
        remark: ''
      },
      cerInfoModal: {},
      uploadRole: '',
      cardImg: '',
      faceImg: '',
      uploadData: {},
      rules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          { pattern: chEnRegExp, message: '格式不正确', trigger: 'change'},
        ],
        cardId: [
          { required: true, message: '请填写证件号码', trigger: 'blur' },
          { pattern: /^[0-9a-zA-Z]+$/ , message: '格式不正确', trigger: 'change' }
        ],
        endDate: [
          { required: true, type: 'date', message: '请填写证件到期日期', trigger: 'change' }
        ],
        cardType: [
          { required: true, type:'number', message: '请选择证件类型', trigger: 'change' }
        ],
        status: [
          { required: true, type:'number', message: '请选择审核状态', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请填写审核反馈', trigger: 'blur' },
          { validator: required, trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    maxSizeErr(){
      this.$Notice.error({
        title: '图片上传失败',
        desc: '图片限制大小为：4Mb'
      })
    },
    handleBeforeUpload(role) {
      this.uploadRole = role;
      this.uploadData["x:fileDirId"] = -1;
      this.uploadData["x:isPrivate"] = 1;
      this.uploadData["x:remark"] = "用户证件照";
    },
    editModalBtn() {
      if(!this.canEdit){
        this.$Notice.error({
          title: '无相关权限'
        })
        return
      }
      this.cerInfoModal = Object.assign({}, this.cerInfo);
      if(this.cerInfoModal.status!=2 && this.cerInfoModal.status!=3){
        this.cerInfoModal.status = ''
      }
      this.editModal = true;
    },
    handleSuccess(res) {
      let url = res.materialBase.url;
      this.$emit('getPrivateToken', url);
    },
    handleFormatError() {
      this.$Notice.warning({
        title: '文件类型不正确',
      });
    },
    subCertificate() {
      this.$refs.editModal.buttonLoading = false;
      this.$refs.cerInfoForm.validate((valid) => {
        if(valid) {
          let param = {
            userId: this.cerInfoModal.userId,
            name: this.cerInfoModal.name,
            certificateIdNo: this.cerInfoModal.cardId,
            certificateValid: Moment(this.cerInfoModal.endDate).format('YYYY.MM.DD'),
            certificateType: this.cerInfoModal.cardType,
            certificateAuditStatus: this.cerInfoModal.status,
            image1: this.cardImg.substring(0,this.cardImg.indexOf("?")),
            image2: this.faceImg.substring(0,this.cardImg.indexOf("?")),
            imageType: 2,
            certificateRejectReason: this.cerInfoModal.remark
          };
          (param.certificateAuditStatus == 2) && (param.certificateRejectReason = '');
          this.editModal = false;
          this.cerInfoModal.endDate = '';
          this.$emit('certificateAudit', param);
        }
      })
    },
    cancel() {
      this.cerInfoModal.endDate = '';
    }
  }
}
</script>

<style lang="scss" scoped>
  h5{
    text-align: center;
    margin-bottom: 5px;
  }
  .upload{
    text-align: center;
    cursor: pointer;
    .upload-box{
      padding-top: 60px;
    }
    .img-box{
      width: 300px;
      height: 190px;
      position: relative;
      padding-top: 0;
      background-color: #eee;
    }
  }
  .upload-bord{
    position: absolute;
    top: 0;
    padding-top: 60px;
    width: 300px;
    height: 190px;
    opacity: 0;
    background-color: #bcbcbc
  }
  .upload-bord:hover{
    opacity: 0.8;
  }
  .upload-box{
    display: inline-block;
    width: 300px;
    height: 190px;
    border: 1px solid #eee;
    background-color: #eee;
  }
  .cardImg{
    text-align: center;
  }
  .tableForm{
    margin-bottom:0 
  }
  .img{
    width: 300px;
    height: 190px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/vip/vip-detail/other-authentication.vue